import React from 'react';

function readConfiguration(value) {
  try {
    const config = typeof value === 'string' ? JSON.parse(value) : value;
    return config && typeof config === 'object' && !Array.isArray(config) ? config : {};
  } catch (_) { return {}; }
}

export default function KioskExperienceSettings({ settings, products, onChange }) {
  const config = readConfiguration(settings.kioskExperienceConfig);
  const steaks = config.steaks || {};
  const enabled = settings.kioskExperience === 'orgasmeat-v1';
  const availableProducts = products.filter(product => product.isBorneAvailable !== false);
  const selectedIds = Object.values(steaks).filter(Boolean).map(Number);
  const complete = selectedIds.length === 6 && new Set(selectedIds).size === 6
    && selectedIds.every(id => availableProducts.some(product => product.id === id));

  return <div className="admin-form-group">
    <div><h3>Expérience de marque</h3><p>Personnalisez la veille, l’accueil et la carte de cette borne.</p></div>
    <label className="admin-field">
      <span>Univers de la borne</span>
      <select value={enabled ? 'orgasmeat-v1' : 'default'} onChange={event => onChange({
        kioskExperience: event.target.value,
        kioskExperienceConfig: event.target.value === 'default' ? {} : { steaks },
      })}>
        <option value="default">Personnalisation classique</option>
        <option value="orgasmeat-v1">ORGASMEAT — 1 à 6 steaks</option>
      </select>
    </label>
    {enabled && <>
      <p>Associez chaque taille à son burger. Les prix, disponibilités et options restent ceux de votre catalogue.</p>
      <div className="admin-form-grid admin-form-grid-2">
        {[1, 2, 3, 4, 5, 6].map(count => <label className="admin-field" key={count}>
          <span>{count} {count === 1 ? 'steak' : 'steaks'}</span>
          <select required value={steaks[count] || ''} onChange={event => onChange({ kioskExperienceConfig: {
            steaks: { ...steaks, [count]: event.target.value ? Number(event.target.value) : '' },
          } })}>
            <option value="">Choisir le burger</option>
            {availableProducts.map(product => <option key={product.id} value={product.id}>
              {product.name} — {Number(product.price).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}
            </option>)}
          </select>
        </label>)}
      </div>
      {!complete && <p role="status">Choisissez six burgers distincts avant d’enregistrer l’expérience.</p>}
      <small>La vidéo et les visuels ORGASMEAT sont inclus. Les réglages classiques restent disponibles en revenant à la personnalisation classique.</small>
    </>}
  </div>;
}
